/* eslint-disable react/require-default-props */
import React from "react";

import Icon from "../../icon";
import { If } from "../../if/if";

import { Overlay, Container, /* Header, */ CloseButton } from "./styles";

import IBaseProps from "./props";

const Modal: React.FC<IBaseProps> = ({
  isVisible,
  toggleVisibility,
  hasHeader = true,
  content: { /* title, */ component: Component, width },
  styles = {},
}) => (
  <Overlay isVisible={isVisible}>
    <Container style={{ width, ...styles }}>
      {/* <If condition={!hasHeader}>
        <Header>
          <h1>{title}</h1>
          <button
            type='button'
            aria-label='Close'
            onClick={() => toggleVisibility(false)}
          >
            <Icon name='close' />
          </button>
        </Header>
      </If> */}
      <If condition={hasHeader}>
        <CloseButton type="button" onClick={() => toggleVisibility(false)}>
          <Icon name="close" size={25} />
        </CloseButton>
      </If>
      <main>{Component && <Component />}</main>
    </Container>
  </Overlay>
);

export default Modal;
